export { default } from './TaxonomyNavigator';
